module.exports = __webpack_public_path__ + "static/media/avc_ticket.963d1b63.svg";